import { ArrowRightOutlined } from "@ant-design/icons";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Tag } from "@impero-com/ui";

import { riskChangeRoot } from "./RiskChange.css";

export type RiskChangeProps =
    | {
          fromLabel: string | undefined;
          fromIndex: number | undefined;
          toLabel: string | undefined;
          toIndex: number | undefined;
      }
    | { noChangeLabel: string; noChangeIndex?: number };

export function RiskChange({ value }: { value: RiskChangeProps }) {
    const { t } = useTranslation();
    const isNoChange = "noChangeLabel" in value;
    if (isNoChange) {
        return (
            <RiskTag label={value.noChangeLabel} index={value.noChangeIndex} />
        );
    }

    return (
        <div className={riskChangeRoot}>
            <RiskTag
                label={value.fromLabel ?? t("RiskDirectory_RiskChange_NoValue")}
                index={value.fromIndex}
            />
            <ArrowRightOutlined />
            <RiskTag
                label={value.toLabel ?? t("RiskDirectory_RiskChange_NoValue")}
                index={value.toIndex}
            />
        </div>
    );
}

// Heat scale for the risk level, low to high.
const METADATA_COLORS = [
    "#c6e4bd", // green
    "#e1edb8", // light green
    "#f7f0b5", // yellow
    "#f9d4b5", // orange
    "#fab3b3", // red
    "#ea9e9e", // dark red
];

interface RiskTagProps {
    label: string;
    index: number | undefined;
}
export function RiskTag({ label, index }: RiskTagProps) {
    if (!label) {
        return <span>-</span>;
    }
    if (index === undefined) {
        return <span>{label}</span>;
    }
    const color = METADATA_COLORS[index % METADATA_COLORS.length];
    return (
        <Tag wrap background={color} borderColor={color}>
            {label}
        </Tag>
    );
}
